import { cubicBezier } from "./cubic-bezier.mjs";
import { mirrorEasing } from "./modifiers/mirror.mjs";
import { reverseEasing } from "./modifiers/reverse.mjs";
const backOut = /* @__PURE__ */ cubicBezier(0.33, 1.53, 0.69, 0.99);
const backIn = /* @__PURE__ */ reverseEasing(backOut);
const backInOut = /* @__PURE__ */ mirrorEasing(backIn);
export {
  backIn,
  backInOut,
  backOut
};
